/**
 * Styled Components - Created by Jesus Apodaca on 12/30/25
 */
import styled from 'styled-components'
import { WHITE } from '../../theme/colors'

export const Container = styled.div`
  background-color: ${WHITE};
  width: 100%;
  max-width: 928px;
  margin: 0 auto;
  padding: 48px 24px;
  box-shadow: 0px 0px 10px -4px gray;
  font-family: Avenir;
  #title {
    font-size: 18px;
    font-weight: 500;
  }
  #goBack {
    margin: 28px 0;
    &:hover {
      cursor: pointer;
      color: cornflowerblue;
    }
  }
  #floatingBar {
    position: fixed;
    bottom: 0;
    background: white;
    left: 0;
    width: 100%;
    padding: 10px;
    border-top: 1px solid lightgray;
    z-index: 1;
  }
  #floatingBtn {
    background: #302628;
    width: fit-content;
    float: right;
    color: white;
    font-weight: 500;
    padding: 8px 72px;
    border-radius: 25px;
    &:hover {
      cursor: pointer;
      opacity: 0.8;
    }
  }
  @media (max-width: 698px) {
    padding: 48px 14px;
    height: 100%;
  }
`

export const Form = styled.div`
  #coupon {
    font-size: 22px;
    font-weight: bold;
    padding-left: 15px;
    margin-bottom: 16px;
  }
  .quickIcon {
    max-width: 17px;
    background: #9d9d9d;
    filter: contrast(4) invert(1);
    border-radius: 25px;
    margin-left: 8px;
    vertical-align: sub;
    &:hover {
      cursor: pointer;
      filter: brightness(1) drop-shadow(0px 0px 1px gray);
    }
  }
  .questionFit {
    font-style: italic;
    margin: 8px 0;
    color: black;
    font-size: 16px;
    font-weight: bold;
  }
  input[type="radio"] {
    margin: 10px;
    width: 16px;
    height: 16px;
    appearance: none;
    outline: 2px solid black;
    border-radius: 50%;
    background-color: transparent;
    cursor: pointer;
    vertical-align: middle;
    border: 2px solid #d9d9d9;
  }
  input[type="radio"]:checked {
    background-color: black;
    padding: 4px;
  }
  textarea {
    width: 100%;
    border-radius: 5px;
    border-color: #cccccc;
    padding: 6px 10px;
    @media (max-width: 698px) {
      font-size: 16px;
    }
    ::placeholder {
      color: #A8A0A1;
    }
  }
  .ast {
    color: red;
  }
  .empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 48px;
    text-align: center;
    background-color: #ffffff;
    border: 1px solid #f3f4f6;
    border-radius: 16px;
    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 
                0 8px 10px -6px rgba(0, 0, 0, 0.05);
    max-width: 420px;
    margin: 2rem auto;
    transition: transform 0.2s ease;
    .icon {
      font-size: 48px;
      margin-bottom: 16px;
      opacity: 0.6;
    }
    .title {
      margin: 0 0 8px 0;
      font-family: sans-serif;
      font-size: 1.25rem;
      color: #111827; /* Near black */
      font-weight: 600;
    }
    .description {
      margin: 0;
      font-family: sans-serif;
      font-size: 0.95rem;
      color: #6b7280; /* Muted gray */
      line-height: 1.5;
    }
  }
  #sendingLayer {
    background: #ffffffa6;
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }
  #loader {
    width: 100%;
    height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`

export const SentScreen = styled.div`
  text-align: center;
  margin-block: 64px 112px;
  display: flex;
  flex-flow: column;
  align-items: center;
  #successImg {
    max-width: 90px;
  }
  #successDesc {
    font-weight: bold;
    font-size: 22px;
    max-width: 388px;
    margin-block: 28px;
  }
  a {
    color: cornflowerblue;
  }
`

export const Card = styled.div`
  background: #F7F7F7;
  border-radius: 6px;
  padding: 16px;
  margin-top: 10px;
  .green {
    color: #0F7F12;
  }
  .light {
    font-weight: 100;
  }
  .profile {
    float: right;
    font-size: 12px;
  }
  .avatar {
    border-radius: 25px;
    color: white;
    padding: 4px;
    margin-right: 8px;
  }
  label {
    display: block;
    margin-bottom: -6px;
  }
  @media (max-width: 698px) {
    padding: 16px 10px;
    position: relative;
    .imageCard {
      width: fit-content;
      align-self: center;
      margin-bottom: 22px;
    }
    .avatar {
      font-size: 10px;
      position: absolute;
      right: 0;
      top: -10px;
      background: #f7f7f7;
      padding: 4px 10px;
      border-radius: 5px;
    }
  }
`

export const TableQuestions = styled.div`
  flex: 1;
  .header {
    display: flex;
    padding: 0px 22px;
  }
  .question {
    display: flex;
    font-weight: 500;
    padding: 0px 22px;
    background: #D9D9D9;
    margin-block: 2px;
    border-radius: 3px;
    align-items: center;
  }
  .left {
    width: 50%;
    padding-left: 8%;
  }
  .option {
    width: 22%;
    text-align: center;
  }
  @media (max-width: 698px) {
    .left {
      padding-left: 0;
    }
    .header {
      padding: 0px 10px;
    }
    .question {
      padding: 0px 10px;
    }
    .option {
      width: 34%;
    }
    .small {
      width: 22%;
      align-self: end;
    }
  }
`

export const Notes = styled.div`
  margin-top: 20px;
  #required {
    color: red;
  }
  .ant-upload-btn {
    margin: 0 auto;
  }
  .ant-upload-drag-container div {
    color: black !important;
  }
  #fileSection {
    display: flex;
    flex-flow: column;
    align-items: center;
    padding: 8px;
    row-gap: 8px;
  }
  .anticon-upload {
    font-size: 24px;
    color: black;
  }
  #noteArea {
    min-height: 100px;
    max-height: 200px;
    field-sizing: content;
  }
`

export const CouponDiv = styled.div`
  height: 100px;
  background: rgb(204, 204, 204);
  font-size: 22px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  .copyBtn {
    font-weight: normal;
    font-size: 12px;
    position: absolute;
    bottom: 8px;
    padding: 2px 12px;
    border-radius: 25px;
    background: #e7e7e7;
    cursor: pointer;
  }
`

export const thumbnailStyles = {
  maxWidth: '200px',
  padding: '8px',
  height: '188px',
  objectFit: 'cover'
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/Feedback/styledComponents.tsx